import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.outstanding_view.topupEligibleTitle',
        defaultMessage: 'Need more funds?'
    },
    preApprovedTitle: {
        id: '_.outstanding_view.topupEligiblePreApprovedTitle',
        defaultMessage: 'Need more than {preApprovedAmount}?'
    },
    description: {
        id: '_.outstanding_view.topupEligibleDescription',
        defaultMessage:
            'You can now request more funds - approval is subject to credit review'
    },
    preApprovedDescription: {
        id: '_.outstanding_view.topupEligiblePreApprovedDescription',
        defaultMessage:
            'You can now request more funds - approval is subject to credit review'
    },
    ctaText: {
        id: '_.outstanding_view.createTopupRequest',
        defaultMessage: 'Request more funds'
    }
});
